/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Auto-apply "In stock" filter when any other filter becomes active.
  // Respects manual removal: if the customer explicitly unchecks availability,
  // we don't force it back on for the rest of that page session.

  var availabilityRemovedByUser = false;

  function hasNonAvailFilter(params) {
    return Array.from(params.keys()).some(function(k) {
      return k.startsWith('filter.') && k !== 'filter.v.availability';
    });
  }

  function injectAvailabilityIntoUrl(url) {
    try {
      var urlObj = new URL(url, window.location.origin);
      var params = urlObj.searchParams;
      var currentParams = new URLSearchParams(window.location.search);

      var hadAvailability = currentParams.has('filter.v.availability');
      var hasAvailability = params.has('filter.v.availability');
      var hasNonAvail = hasNonAvailFilter(params);

      if (!hasNonAvail) {
        // All filters cleared — reset flag and don't inject
        availabilityRemovedByUser = false;
        return url;
      }

      if (hadAvailability && !hasAvailability) {
        // User explicitly removed the availability chip while other filters remain
        availabilityRemovedByUser = true;
        return url;
      }

      if (!hasAvailability && !availabilityRemovedByUser) {
        params.set('filter.v.availability', '1');
        var newSearch = params.toString();
        return urlObj.pathname + (newSearch ? '?' + newSearch : '');
      }

      return url;
    } catch (e) {
      return url;
    }
  }

  customElements.whenDefined('collection-filters-form').then(function() {
    var CollectionFiltersForm = customElements.get('collection-filters-form');
    if (!CollectionFiltersForm) return;

    var origSubmitForm = CollectionFiltersForm.prototype.submitForm;

    CollectionFiltersForm.prototype.submitForm = function(event, url) {
      if (url === undefined) url = '';

      // Only intercept non-popstate paths; popstate (back/forward) is handled by the original
      if (!event || event.type !== 'popstate') {

        if (url === '') {
          // Form-based submission: inspect what the form currently has checked
          if (this.form) {
            var formParams = new URLSearchParams(new FormData(this.form));
            var currentParams = new URLSearchParams(window.location.search);

            var hadAvailability = currentParams.has('filter.v.availability');
            var formHasAvailability = formParams.has('filter.v.availability');
            var formHasNonAvail = hasNonAvailFilter(formParams);

            if (!formHasNonAvail) {
              // All filters cleared — reset flag
              availabilityRemovedByUser = false;

            } else if (hadAvailability && !formHasAvailability) {
              // User unchecked availability while other filters are still active
              availabilityRemovedByUser = true;

            } else if (!formHasAvailability && !availabilityRemovedByUser) {
              // Inject: check the "In stock" checkbox so FormData picks it up
              var avCheckbox = this.form.querySelector('input[name="filter.v.availability"][value="1"]');
              if (avCheckbox && !avCheckbox.disabled) {
                avCheckbox.checked = true;
              } else if (!avCheckbox) {
                // Fallback when availability isn't exposed as a visible filter option
                var existing = this.form.querySelector('input[data-auto-avail]');
                if (!existing) {
                  var hidden = document.createElement('input');
                  hidden.type = 'hidden';
                  hidden.name = 'filter.v.availability';
                  hidden.value = '1';
                  hidden.setAttribute('data-auto-avail', '');
                  this.form.appendChild(hidden);
                }
              }
            }

            // Clean up any previously injected hidden input when no longer needed
            if (formHasAvailability || availabilityRemovedByUser || !formHasNonAvail) {
              var injected = this.form.querySelector('input[data-auto-avail]');
              if (injected) injected.remove();
            }
          }

        } else {
          // URL-based submission (active filter chip removal / clear-all links)
          url = injectAvailabilityIntoUrl(url);
        }
      }

      return origSubmitForm.call(this, event, url);
    };
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
